import { doorClient, resolve, leyanbotClient } from 'services/api';
import type { SpuClass, Spu, Knowledge, RecommendToConfigItem } from './type';

export const getSpuClass = () => {
  return resolve<SpuClass[]>(doorClient.get('/knowledge/spu_knowledges/spu_class'));
};

export const getSpuClassSpus = (spuClassId: number) => {
  return resolve<Spu[]>(
    doorClient.get('/knowledge/spu_knowledges/spu_class/spus', {
      params: {
        spuClassId,
      },
    }),
  );
};

export const getSpuClassKnowledges = (spuClassId: number) => {
  return resolve<Knowledge[]>(
    doorClient.get('/knowledge/spu_knowledges/spu_class/knowledges/v2', {
      params: {
        spuClassId,
      },
    }),
  );
};

export const getSpuClassKnowledgeDetail = (params: {
  spuClassId?: number;
  knowledgeId: string | number;
}) => {
  return resolve<Knowledge>(
    doorClient.get('/knowledge/spu_knowledges/spu_class/knowledge_detail', {
      params,
    }),
  );
};

// 查询重要商品
export const getImportantSpus = () => {
  return doorClient.post<{
    internalItemId: string[];
  }>('/item/v1/important_items', undefined);
};

export const getRecommendToConfig = () => {
  return resolve<{
    totalProgress: number;
    recommendToConfigItems: RecommendToConfigItem[];
  }>(leyanbotClient.get('/oversea-knowledge/spu_knowledges/v3/recommend_to_config'));
};

export type MarkCompleteData = { itemInternalId: string; type: 'complete' | 'skip' };
export const markComplete = (data: MarkCompleteData) => {
  return leyanbotClient.post('/oversea-knowledge/spu_knowledges/v3/recommend_mark_complete', data);
};

export const updateKnowledgeStatus = (data: { openIds: string[]; shutdownIds: string[] }) => {
  return leyanbotClient.post('/oversea-knowledge/spu_knowledges/v3/spu_knowledge_status', data);
};

export const setKnowledgeDefault = (data: {
  spuKnowledgeDefinitionId: number;
  defaultValueId: string;
}) => {
  return leyanbotClient.put('/oversea-knowledge/spu_knowledges/v3/knowledge_default_value', data);
};
